module.exports = __webpack_public_path__ + "static/media/Button_Increase.4dc48312.png";